import { CONFIG } from 'common/utils';

export const forgotPasswordText =
  'No problem! Fill in the details below. If these details are correct, you will receive an email allowing you to select a new password.';

export const changePasswordText =
  'Need to change your password? You’re in the right spot.';

export const changePasswordHelp = `Enter your email to request a password reset. You must use the email associated with your ${CONFIG.BRAND} account.`;
